(() => {
  const root = document.querySelector("[data-gtq]");
  if (!root) return;

  // ✅ Your Render backend base
  const GTQ_BACKEND_BASE = "https://gtq-backend.onrender.com";

  // Disable browser scroll restoration
  try {
    if ("scrollRestoration" in history) history.scrollRestoration = "manual";
  } catch (e) {}

  /***********************
   * Elements
   ***********************/
  const tiles = [...root.querySelectorAll("[data-gtq-category]")];
  const form = root.querySelector("[data-gtq-form]");
  const inputCategory = root.querySelector("[data-gtq-input-category]");

  const brandRow = root.querySelector("[data-gtq-brand-row]");
  const modelRow = root.querySelector("[data-gtq-model-row]");

  const brandLabel = root.querySelector("[data-gtq-brand-label]");
  const brandSelect = root.querySelector("[data-gtq-brand]");
  const modelSelect = root.querySelector("[data-gtq-model]");
  const modelSearch = root.querySelector("[data-gtq-model-search]");
  const backBtn = root.querySelector("[data-gtq-back]");

  const pcFields = root.querySelector("[data-gtq-pc-fields]");
  const pcGpu = root.querySelector("[data-gtq-pc-gpu]");
  const pcCpu = root.querySelector("[data-gtq-pc-cpu]");
  const pcRam = root.querySelector("[data-gtq-pc-ram]");
  const pcStorage = root.querySelector("[data-gtq-pc-storage]");
  const pcCooling = root.querySelector("[data-gtq-pc-cooling]");

  const pcGpuSearch = root.querySelector("[data-gtq-pc-gpu-search]");
  const pcCpuSearch = root.querySelector("[data-gtq-pc-cpu-search]");
  const pcRamSearch = root.querySelector("[data-gtq-pc-ram-search]");
  const pcStorageSearch = root.querySelector("[data-gtq-pc-storage-search]");

  const conditionSelect = root.querySelector("[data-gtq-condition]");
  const qtyInput = root.querySelector("[data-gtq-qty]");
  const payoutSelect = root.querySelector("[data-gtq-payout]");
  const resetBtn = root.querySelector("[data-gtq-reset]");

  const emailInput = root.querySelector("[data-gtq-email]");
  const emailError = root.querySelector("[data-gtq-email-error]");

  const phoneInput = root.querySelector("[data-gtq-phone]");
  const phoneError = root.querySelector("[data-gtq-phone-error]");

  const lockBody = root.querySelector("[data-gtq-lock-body]");
  const honeypot = root.querySelector("[data-gtq-honeypot]");
  const lockSubmit = root.querySelector("[data-gtq-lock-submit]");
  const lockEmail = root.querySelector("#gtq-email2");
  const lockPhone = root.querySelector("#gtq-phone");

  const lockForm = lockBody ? lockBody.closest("form") : null;
  const lockFieldsWrap = root.querySelector("[data-gtq-lock-fields]");
  const lockSuccess = root.querySelector("[data-gtq-lock-success]");
  const lockError = root.querySelector("[data-gtq-lock-error]");
  const anotherQuoteBtn = root.querySelector("[data-gtq-another-quote]");

  const outCategory = root.querySelector("[data-gtq-out-category]");
  const outModel = root.querySelector("[data-gtq-out-model]");
  const outCondition = root.querySelector("[data-gtq-out-condition]");
  const outQty = root.querySelector("[data-gtq-out-qty]");
  const outPrice = root.querySelector("[data-gtq-out-price]");

  const previewPart = root.querySelector("[data-gtq-preview-part]");
  const previewCond = root.querySelector("[data-gtq-preview-cond]");
  const previewPrice = root.querySelector("[data-gtq-preview-price]");

  const topQuote = root.querySelector("#gtq-top") || root.querySelector("[data-gtq-top]");

  let lastLeadEmail = "";
  let lastLeadPhone = "";
  let lastQuotePayload = null;

  /***********************
   * Helpers
   ***********************/
function sendLead(path, payload) {
  const url = `${GTQ_BACKEND_BASE}${path}`;
  const body = JSON.stringify(payload);

  // Best effort, never block UX
  try {
    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: "application/json" });
      navigator.sendBeacon(url, blob);
      return;
    }
  } catch (e) {}

  fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body,
    keepalive: true
  }).catch(() => {});
}

  function formatCAD(n) {
    if (!Number.isFinite(n)) return "$—";
    return n.toLocaleString("en-CA", {
      style: "currency",
      currency: "CAD",
      maximumFractionDigits: 0
    });
  }

  function setOptions(select, options) {
    if (!select) return;
    select.innerHTML = "";
    (options || []).forEach((opt, idx) => {
      const o = document.createElement("option");
      o.value = opt;
      o.textContent = opt;
      if (idx === 0) o.selected = true;
      select.appendChild(o);
    });
  }

  function filterSelectOptions(select, query) {
    if (!select) return;
    const q = (query || "").trim().toLowerCase();
    const opts = [...select.options];

    if (!q) {
      opts.forEach(o => (o.hidden = false));
      return;
    }

    opts.forEach(o => {
      o.hidden = !o.textContent.toLowerCase().includes(q);
    });

    const firstVisible = opts.find(o => !o.hidden);
    if (firstVisible) select.value = firstVisible.value;
  }

  function forceScrollTo(el) {
    if (!el) return;
    const doScroll = () => {
      const y = el.getBoundingClientRect().top + window.pageYOffset - 20;
      window.scrollTo({ top: y, behavior: "auto" });
    };
    requestAnimationFrame(() => {
      doScroll();
      requestAnimationFrame(doScroll);
    });
  }

  function syncPreview() {
    if (previewPart) previewPart.textContent = inputCategory?.value || "—";
    if (previewCond) previewCond.textContent =
      conditionSelect?.options?.[conditionSelect.selectedIndex]?.textContent || "—";
    if (previewPrice) previewPrice.textContent = outPrice?.textContent || "$—";
  }

  function updateBrandLabel(category) {
    if (!brandLabel) return;
    const map = {
      GPU: "Brand",
      CPU: "Brand",
      Motherboard: "Platform / Socket",
      RAM: "Memory Type",
      Storage: "Storage Type",
      "Full Gaming PC": "Brand"
    };
    brandLabel.textContent = map[category] || "Brand";
  }

  function updateSearchVisibilityAndPlaceholder(category) {
    if (!modelSearch) return;

    // Show search for everything except Full PC (since Full PC has its own fields)
    const hideFor = ["Full Gaming PC"];
    const shouldShow = !hideFor.includes(category);

    if (!shouldShow) {
      modelSearch.style.display = "none";
      modelSearch.value = "";
      filterSelectOptions(modelSelect, "");
      return;
    }

    modelSearch.style.display = "";
    modelSearch.placeholder = "Search (type to filter)…";
  }

  /***********************
   * Views (hash)
   ***********************/
  const HASH_QUOTE = "#__gtq_quote";
  const HASH_ESTIMATE = "#__gtq_estimate";

  function setHash(hash) {
    const base = window.location.href.split("#")[0];
    history.pushState({ gtq: hash.replace("#__", "") }, "", base + hash);
  }

  function goToEstimateView(push = true) {
    root.classList.add("gtq--estimate");
    if (push && window.location.hash !== HASH_ESTIMATE) setHash(HASH_ESTIMATE);
    forceScrollTo(topQuote || root);
  }

  function goToQuoteView(push = true) {
    root.classList.remove("gtq--estimate");
    if (push && window.location.hash !== HASH_QUOTE) setHash(HASH_QUOTE);
    forceScrollTo(topQuote || root);
  }

  if (backBtn) backBtn.addEventListener("click", () => goToQuoteView(true));

  window.addEventListener("popstate", () => {
    if (window.location.hash === HASH_ESTIMATE) goToEstimateView(false);
    else goToQuoteView(false);
  });

  function normalizeHashOnce() {
    const base = window.location.href.split("#")[0];
    const h = window.location.hash || "";
    const toEstimate = ["#gtq-estimate", "#gtq-estimate-top", "#estimate", HASH_ESTIMATE];
    const toQuote = ["", "#gtq-top", "#gtq-form", "#gtq-how", "#how", "#quote", HASH_QUOTE];

    if (toEstimate.includes(h)) {
      history.replaceState({ gtq: "estimate" }, "", base + HASH_ESTIMATE);
      return HASH_ESTIMATE;
    }

    if (toQuote.includes(h)) {
      history.replaceState({ gtq: "quote" }, "", base + HASH_QUOTE);
      return HASH_QUOTE;
    }

    history.replaceState({ gtq: "quote" }, "", base + HASH_QUOTE);
    return HASH_QUOTE;
  }

  /***********************
   * Lead validation
   ***********************/
  function setEmailError(msg) {
    if (emailInput) {
      if (msg) {
        emailInput.classList.add("gtq__input--error");
        emailInput.setAttribute("aria-invalid", "true");
      } else {
        emailInput.classList.remove("gtq__input--error");
        emailInput.removeAttribute("aria-invalid");
      }
    }
    if (emailError) {
      if (msg) {
        emailError.style.display = "";
        emailError.textContent = msg;
      } else {
        emailError.style.display = "none";
        emailError.textContent = "";
      }
    }
  }

  function isValidEmailFormat(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
  }

  function requireLeadEmailOrStop() {
    const email = (emailInput?.value || "").trim();
    if (!email) {
      setEmailError("Email required.");
      emailInput?.focus();
      return { ok: false, email: "" };
    }
    if (!isValidEmailFormat(email)) {
      setEmailError("Please enter a valid email.");
      emailInput?.focus();
      return { ok: false, email: "" };
    }
    setEmailError("");
    lastLeadEmail = email;
    return { ok: true, email };
  }

  function setPhoneError(msg) {
    if (phoneInput) {
      if (msg) {
        phoneInput.classList.add("gtq__input--error");
        phoneInput.setAttribute("aria-invalid", "true");
      } else {
        phoneInput.classList.remove("gtq__input--error");
        phoneInput.removeAttribute("aria-invalid");
      }
    }
    if (phoneError) {
      if (msg) {
        phoneError.style.display = "";
        phoneError.textContent = msg;
      } else {
        phoneError.style.display = "none";
        phoneError.textContent = "";
      }
    }
  }

  function getDigits10(v) {
    return (v || "").replace(/\D/g, "").slice(0, 10);
  }

  function requireLeadPhoneOrStop() {
    const digits = getDigits10(phoneInput?.value || "");
    if (!digits || digits.length !== 10) {
      setPhoneError("Please enter a valid 10-digit phone number.");
      phoneInput?.focus();
      return { ok: false, phone: "" };
    }
    setPhoneError("");
    lastLeadPhone = digits;
    return { ok: true, phone: digits };
  }

  if (phoneInput) {
    phoneInput.addEventListener("paste", (e) => e.preventDefault());
    phoneInput.addEventListener("keydown", (e) => {
      const allowed = ["Backspace","Delete","ArrowLeft","ArrowRight","ArrowUp","ArrowDown","Tab","Home","End"];
      if (allowed.includes(e.key)) return;
      if (e.ctrlKey || e.metaKey) return;
      if (!/^\d$/.test(e.key)) e.preventDefault();
    });
    phoneInput.addEventListener("input", () => {
      const digits = getDigits10(phoneInput.value);
      if (phoneInput.value !== digits) phoneInput.value = digits;
      if (phoneInput.classList.contains("gtq__input--error") && digits.length === 10) setPhoneError("");
    });
  }

  /***********************
 * Rate limiting (front-end only, persists across refresh/tabs)
 ***********************/
const GTQ_QUOTE_LIMIT_KEY = "gtq_quote_times_v1";

function readQuoteTimes() {
  try {
    const raw = localStorage.getItem(GTQ_QUOTE_LIMIT_KEY);
    const arr = JSON.parse(raw || "[]");
    return Array.isArray(arr) ? arr : [];
  } catch (e) {
    return [];
  }
}

function writeQuoteTimes(arr) {
  try {
    localStorage.setItem(GTQ_QUOTE_LIMIT_KEY, JSON.stringify(arr));
  } catch (e) {}
}

function canQuoteNow() {
  const now = Date.now();
  const WINDOW_MS = 10 * 60 * 1000; // 10 minutes
  const MAX_QUOTES = 5;

  // Keep only quotes inside the window
  let times = readQuoteTimes().filter(t => now - t < WINDOW_MS);

  if (times.length >= MAX_QUOTES) return false;

  times.push(now);
  writeQuoteTimes(times);
  return true;
}


  /***********************
   * Catalog (must match CSV)
   ***********************/
  const CATALOG = window.GTQ_CATALOG || {
    GPU: {
      NVIDIA: [],
      AMD: []
    },
    CPU: {
      Intel: [],
      AMD: []
    },
    Motherboard: {
      "Intel LGA1851 (Core Ultra)": [
        "Z890 (High-end)","B860 (Mainstream)","H810 (Entry)"
      ],
      "Intel LGA1700 (12th-14th Gen)": [
        "Z790 (High-end)","Z690 (High-end)","B760 (Mainstream)","B660 (Mainstream)","H770 (Mainstream)","H670 (Mainstream)","H610 (Entry)"
      ],
      "Intel LGA1200 (10th-11th Gen)": [
        "Z590 (High-end)","Z490 (High-end)","B560 (Mainstream)","B460 (Mainstream)","H570 (Mainstream)","H470 (Mainstream)","H510 (Entry)","H410 (Entry)"
      ],
      "Intel LGA1151 (6th-9th Gen)": [
        "Z390 (High-end)","Z370 (High-end)","Z270 (High-end)","Z170 (High-end)","B365 (Mainstream)","B360 (Mainstream)","B250 (Mainstream)","B150 (Mainstream)","H370 (Mainstream)","H270 (Mainstream)","H170 (Mainstream)","H310 (Entry)","H110 (Entry)"
      ],
      "AMD AM5 (Ryzen 7000)": [
        "X870E (High-end)","X870 (High-end)","B850E (Mainstream+)","B850 (Mainstream)","X670E (High-end)","X670 (High-end)","B650E (Mainstream+)","B650 (Mainstream)","A620 (Entry)"
      ],
      "AMD AM4 (Ryzen 1000-5000)": [
        "X570 (High-end)","X470 (High-end)","X370 (High-end)","B550 (Mainstream)","B450 (Mainstream)","B350 (Mainstream)","A520 (Entry)","A320 (Entry)"
      ]
    },
    RAM: {
      DDR5: ["16GB","32GB","48GB","64GB","128GB"],
      DDR4: ["8GB","16GB","32GB","64GB","128GB"],
      "DDR3 (Legacy)": ["4GB","8GB","16GB","32GB","64GB","128GB"]
    },
    Storage: {
      "NVMe SSD": ["250GB","500GB","1TB","2TB","4TB","8TB"],
      "SATA SSD": ["120GB","240GB","480GB","500GB","1TB","2TB","4TB"],
      HDD: ["500GB","1TB","2TB","4TB","6TB","8TB","10TB","12TB","14TB","16TB"]
    },
    "Full Gaming PC": {
      GamerTech: ["Custom Spec (CPU+GPU+RAM)"]
    }
  };

  function flattenCategoryModels(category) {
    const entry = CATALOG[category];
    if (!entry || typeof entry !== "object") return [];
    const out = [];
    Object.keys(entry).forEach((brand) => {
      const arr = entry[brand];
      if (Array.isArray(arr)) out.push(...arr);
    });
    return [...new Set(out)].sort((a, b) => a.localeCompare(b, "en"));
  }

  /***********************
   * Dropdown wiring
   ***********************/
  function populateBrandAndModel(category) {
    const entry = CATALOG[category];
    if (!entry) return;

    const brands = Object.keys(entry);
    setOptions(brandSelect, brands);

    const firstBrand = brands[0];
    setOptions(modelSelect, entry[firstBrand] || []);

    if (modelSearch) modelSearch.value = "";
    filterSelectOptions(modelSelect, "");
  }

  function handleBrandChange() {
    const category = inputCategory.value;
    const entry = CATALOG[category];
    if (!entry) return;

    const brand = brandSelect.value;
    setOptions(modelSelect, entry[brand] || []);

    if (modelSearch) modelSearch.value = "";
    filterSelectOptions(modelSelect, "");
  }

  function setReq(el, required) {
    if (!el) return;
    if (required) el.setAttribute("required", "required");
    else el.removeAttribute("required");
  }

  function setDisabled(el, disabled) {
    if (!el) return;
    el.disabled = !!disabled;
  }

  function togglePcMode(isPc) {
    if (brandRow) brandRow.style.display = isPc ? "none" : "";
    if (modelRow) modelRow.style.display = isPc ? "none" : "";
    if (pcFields) pcFields.style.display = isPc ? "" : "none";

    setDisabled(brandSelect, isPc);
    setDisabled(modelSelect, isPc);
    setReq(brandSelect, !isPc);
    setReq(modelSelect, !isPc);

    const pcInputs = [pcGpu, pcCpu, pcRam, pcStorage, pcCooling];
    pcInputs.forEach((el) => {
      setDisabled(el, !isPc);
      setReq(el, isPc);
    });

    const pcSearches = [pcGpuSearch, pcCpuSearch, pcRamSearch, pcStorageSearch];
    pcSearches.forEach((el) => setDisabled(el, !isPc));
  }

  function populatePcFields() {
    if (!pcFields) return;

    setOptions(pcGpu, flattenCategoryModels("GPU"));
    setOptions(pcCpu, flattenCategoryModels("CPU"));
    setOptions(pcRam, flattenCategoryModels("RAM"));
    setOptions(pcStorage, flattenCategoryModels("Storage"));

    // ✅ Force sensible Full PC defaults
    if (pcGpu) pcGpu.value = "RTX 4060 Ti";
    if (pcCpu) pcCpu.value = "Ryzen 7 5800X";
    if (pcRam) pcRam.value = "16GB";
    if (pcStorage) pcStorage.value = "1TB";


    if (pcGpuSearch) pcGpuSearch.value = "";
    if (pcCpuSearch) pcCpuSearch.value = "";
    if (pcRamSearch) pcRamSearch.value = "";
    if (pcStorageSearch) pcStorageSearch.value = "";

    filterSelectOptions(pcGpu, "");
    filterSelectOptions(pcCpu, "");
    filterSelectOptions(pcRam, "");
    filterSelectOptions(pcStorage, "");

    if (pcCooling) pcCooling.value = "air";
  }

  function selectCategory(category) {
    inputCategory.value = category;
    updateBrandLabel(category);

    const isPc = category === "Full Gaming PC";
    togglePcMode(isPc);

    tiles.forEach((b) => {
      const active = b.getAttribute("data-gtq-category") === category;
      b.classList.toggle("is-active", active);
      b.setAttribute("aria-pressed", active ? "true" : "false");
    });

    if (isPc) {
      populatePcFields();
    } else {
      populateBrandAndModel(category);
      updateSearchVisibilityAndPlaceholder(category);
    }

    if (outCategory) outCategory.textContent = category;
    if (outModel) outModel.textContent = "—";
    if (outCondition) outCondition.textContent =
      conditionSelect?.options?.[conditionSelect.selectedIndex]?.textContent || "—";
    if (outQty) outQty.textContent = qtyInput?.value || "1";
    if (outPrice) outPrice.textContent = "$—";
    syncPreview();
  }

  tiles.forEach((btn) => {
    btn.addEventListener("click", () => selectCategory(btn.getAttribute("data-gtq-category")));
  });

  if (brandSelect) brandSelect.addEventListener("change", handleBrandChange);

  if (modelSearch) modelSearch.addEventListener("input", () => filterSelectOptions(modelSelect, modelSearch.value));
  if (pcGpuSearch) pcGpuSearch.addEventListener("input", () => filterSelectOptions(pcGpu, pcGpuSearch.value));
  if (pcCpuSearch) pcCpuSearch.addEventListener("input", () => filterSelectOptions(pcCpu, pcCpuSearch.value));
  if (pcRamSearch) pcRamSearch.addEventListener("input", () => filterSelectOptions(pcRam, pcRamSearch.value));
  if (pcStorageSearch) pcStorageSearch.addEventListener("input", () => filterSelectOptions(pcStorage, pcStorageSearch.value));

  /***********************
   * Build selections (MATCH CSV EXACTLY)
   ***********************/
  function buildSelectionsForSinglePart(category) {
    const subgroup = brandSelect?.value || "";
    const item = modelSelect?.value || "";

    // CSV brand rules:
    // - GPU/CPU brand = NVIDIA/AMD/Intel (from dropdown)
    // - Motherboard/RAM/Storage brand = N/A
    let brand = subgroup;

    if (category === "GPU" || category === "CPU") {
      brand = brandSelect?.value || "";
      // For GPU/CPU, subgroup is always "Consumer Desktop"
      return [{
        Category: category,
        Subgroup: "Consumer Desktop",
        Brand: brand,
        Item: item
      }];
    }

    if (category === "Motherboard" || category === "RAM" || category === "Storage") {
      return [{
        Category: category,
        Subgroup: subgroup,
        Brand: "N/A",
        Item: item
      }];
    }

    return [];
  }

  function buildSelectionsForFullPC() {
    const gpuItem = pcGpu?.value || "";
    const cpuItem = pcCpu?.value || "";
    const ramItem = pcRam?.value || "";

    // Determine GPU brand from the selected GPU text by checking which catalog contains it
    function findGpuBrand(item) {
      const g = CATALOG.GPU || {};
      for (const b of Object.keys(g)) {
        if ((g[b] || []).includes(item)) return b;
      }
      return "NVIDIA"; // fallback
    }

    function findCpuBrand(item) {
      const c = CATALOG.CPU || {};
      for (const b of Object.keys(c)) {
        if ((c[b] || []).includes(item)) return b;
      }
      return "Intel"; // fallback
    }

    const gpuBrand = findGpuBrand(gpuItem);
    const cpuBrand = findCpuBrand(cpuItem);

    return [
      { Category: "GPU", Subgroup: "Consumer Desktop", Brand: gpuBrand, Item: gpuItem },
      { Category: "CPU", Subgroup: "Consumer Desktop", Brand: cpuBrand, Item: cpuItem },
      { Category: "RAM", Subgroup: (findRamSubgroup(ramItem)), Brand: "N/A", Item: ramItem },
    ];
  }

  function findRamSubgroup(ramItem) {
    const r = CATALOG.RAM || {};
    for (const sub of Object.keys(r)) {
      if ((r[sub] || []).includes(ramItem)) return sub;
    }
    return "DDR5";
  }

  /***********************
   * Call backend
   ***********************/
  async function fetchQuote({ selections, mode }) {
    const res = await fetch(`${GTQ_BACKEND_BASE}/api/quote`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ selections, mode })
    });

    const data = await res.json().catch(() => null);
    if (!data) return { ok: false, error: "Bad response from server" };
    return data;
  }

  function renderOfferBoth(cash, credit) {
    // Always show BOTH so customer sees the difference
    const html =
      `<div style="display:grid;gap:6px;">` +
        `<div><strong>Cash Offer:</strong> ${formatCAD(cash)}</div>` +
        `<div><strong>Store Credit:</strong> ${formatCAD(credit)}</div>` +
      `</div>`;

    if (outPrice) outPrice.innerHTML = html;
    if (previewPrice) previewPrice.textContent = formatCAD(payoutSelect?.value === "credit" ? credit : cash);
  }

  /***********************
   * Submit (Get Instant Quote)
   ***********************/
  if (form) {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();

      const emailGate = requireLeadEmailOrStop();
      if (!emailGate.ok) return;

      const phoneGate = requireLeadPhoneOrStop();
      if (!phoneGate.ok) return;

      if (!canQuoteNow()) {
        alert("Please wait a moment — too many quotes in a short time.");
        return;
      }

      const category = inputCategory.value;
      const condition = conditionSelect?.value || "like_new";
      const quantity = Math.max(1, parseInt(qtyInput?.value || "1", 10));
      const payout = payoutSelect?.value || "cash";

      let selections = [];
      let mode = "part";

      if (category === "Full Gaming PC") {
        mode = "pc";
        selections = buildSelectionsForFullPC();

      if (outModel) {
        outModel.textContent =
        `${pcGpu?.value || "—"} • ${pcCpu?.value || "—"} • ${pcRam?.value || "—"} • ${pcStorage?.value || "—"} • ${pcCooling?.value || "—"}`;
      }


        if (lockBody) {
          lockBody.value =
            `Trade-In Quote Request\n\n` +
            `Lead Email: ${emailGate.email}\n` +
            `Lead Phone: ${phoneGate.phone}\n\n` +
            `Category: Full Gaming PC\n` +
            `GPU: ${pcGpu?.value || ""}\n` +
            `CPU: ${pcCpu?.value || ""}\n` +
            `RAM: ${pcRam?.value || ""}\n` +
            `Condition: ${conditionSelect?.options?.[conditionSelect.selectedIndex]?.textContent || "—"}\n` +
            `Quantity: ${quantity}\n` +
            `Preferred Payout: ${payout === "credit" ? "Store Credit" : "Cash"}\n` +
            `Page: ${window.location.href}\n`;
        }
      } else {
        selections = buildSelectionsForSinglePart(category);

        if (outModel) outModel.textContent = `${brandSelect?.value || "—"} • ${modelSelect?.value || "—"}`;

        if (lockBody) {
          lockBody.value =
            `Trade-In Quote Request\n\n` +
            `Lead Email: ${emailGate.email}\n` +
            `Lead Phone: ${phoneGate.phone}\n\n` +
            `Category: ${category}\n` +
            `Subgroup: ${brandSelect?.value || ""}\n` +
            `Item: ${modelSelect?.value || ""}\n` +
            `Condition: ${conditionSelect?.options?.[conditionSelect.selectedIndex]?.textContent || "—"}\n` +
            `Quantity: ${quantity}\n` +
            `Preferred Payout: ${payout === "credit" ? "Store Credit" : "Cash"}\n` +
            `Page: ${window.location.href}\n`;
        }
      }

      // Call backend
      const result = await fetchQuote({ selections, mode });

      if (!result.ok) {
        alert(result.error || "Unable to generate quote. Please try again.");
        return;
      }

      // Multiply by quantity (backend returns per-selection total; your csv entries are per item)
      const cashTotal = (Number(result.cash || 0) * quantity);
      const creditTotal = (Number(result.credit || 0) * quantity);

      // Save last quote payload (for thank-you page if needed)
      lastQuotePayload = {
        timestamp: Date.now(),
        category,
        mode,
        selections,
        quantity,
        payout,
        cash: cashTotal,
        credit: creditTotal
      };

          // Save Step 1 lead (BROWSING) to backend (non-blocking)
      sendLead("/api/leads/quote", {
      email: lastLeadEmail,
      phone: lastLeadPhone,
      category,
      mode,
      selections,
      quantity,
      cash: cashTotal,
      credit: creditTotal,
      page: window.location.href
    });

      if (outCategory) outCategory.textContent = category;
      if (outCondition) outCondition.textContent = conditionSelect?.options?.[conditionSelect.selectedIndex]?.textContent || "—";
      if (outQty) outQty.textContent = String(quantity);

      // Always show both offers
      renderOfferBoth(cashTotal, creditTotal);

      if (previewPart) previewPart.textContent = category;
      if (previewCond) previewCond.textContent = outCondition?.textContent || "—";

      // Autofill lock-in fields
      if (lockEmail && lastLeadEmail) lockEmail.value = lastLeadEmail;
      if (lockPhone && lastLeadPhone) lockPhone.value = lastLeadPhone;

      // Reset lock-in UI state
      if (lockSuccess) lockSuccess.style.display = "none";
      if (lockFieldsWrap) lockFieldsWrap.style.display = "";
      if (lockError) lockError.style.display = "none";
      if (lockSubmit) {
        lockSubmit.removeAttribute("disabled");
        lockSubmit.textContent = "Lock In My Quote";
      }

      goToEstimateView(true);
    });
  }

  /***********************
   * Reset
   ***********************/
  if (resetBtn) {
    resetBtn.addEventListener("click", () => {
      if (qtyInput) qtyInput.value = "1";
      if (conditionSelect) conditionSelect.value = "like_new";
      setEmailError("");
      setPhoneError("");
      selectCategory("GPU");
      goToQuoteView(true);
    });
  }

  /***********************
   * Lock-in submit (Shopify normal submit)
   ***********************/
  function setLockError(msg) {
    if (!lockError) return;
    if (msg) {
      lockError.style.display = "";
      lockError.textContent = msg;
    } else {
      lockError.style.display = "none";
      lockError.textContent = "";
    }
  }

  if (anotherQuoteBtn) {
    anotherQuoteBtn.addEventListener("click", () => {
      try { sessionStorage.removeItem("gtq_last_quote"); } catch (e) {}
      goToQuoteView(true);
    });
  }

  if (lockForm) {
    lockForm.addEventListener("submit", (e) => {
      // bot trap
      if (honeypot && honeypot.value && honeypot.value.trim().length > 0) {
        e.preventDefault();
        return;
      }

      setLockError("");

      // Carry over lead info if empty
      if (lockEmail && (!lockEmail.value || !lockEmail.value.trim()) && lastLeadEmail) lockEmail.value = lastLeadEmail;
      if (lockPhone && (!lockPhone.value || !lockPhone.value.trim()) && lastLeadPhone) lockPhone.value = lastLeadPhone;

      if (typeof lockForm.reportValidity === "function" && !lockForm.reportValidity()) {
        e.preventDefault();
        return;
      }

      // Save for thank-you page
      try {
        if (lastQuotePayload) {
          sessionStorage.setItem("gtq_last_quote", JSON.stringify(lastQuotePayload));
        }
      } catch (e) {}
      // Save Step 2 lead (COMPLETED) to backend (non-blocking)
      try {
        sendLead("/api/leads/lock", {
          name: (root.querySelector("#gtq-name")?.value || "").trim(),
          email: (lockEmail?.value || lastLeadEmail || "").trim(),
          phone: getDigits10(lockPhone?.value || lastLeadPhone || ""),
          category: lastQuotePayload?.category || null,
          mode: lastQuotePayload?.mode || null,
          selections: lastQuotePayload?.selections || null,
          quantity: lastQuotePayload?.quantity || null,
          cash: lastQuotePayload?.cash || null,
          credit: lastQuotePayload?.credit || null,
          page: window.location.href
        });
      } catch (e) {}
      // Prevent double-submits
      if (lockSubmit) {
        lockSubmit.setAttribute("disabled", "disabled");
        lockSubmit.textContent = "Submitting…";
      }
    });
  }

  /***********************
   * Init
   ***********************/
  normalizeHashOnce();
  if (window.location.hash === HASH_ESTIMATE) root.classList.add("gtq--estimate");
  else root.classList.remove("gtq--estimate");
  selectCategory(inputCategory?.value || "GPU");
  syncPreview();
})();